import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

export interface HourlyVolumeData {
  hour: number
  resolvedCount: number
  timeoutCount: number
  rejectedCount: number
  totalCount: number
  resolvedPercentage: number
  timeoutPercentage: number
  rejectedPercentage: number
}

export interface AutonomousSystem {
  systemId: string
  totalEngagements: number
  trend: number
}

export interface ProgramDailyOverview {
  hourlyData: HourlyVolumeData[]
  totalEngagements: number
  date: string
  trend: number
  autonomousSystems: AutonomousSystem[]
  avgEngagementsPerRobot: number
  avgEngagementsPerRobotTrend: number
}

interface UseDailyOverviewParams {
  programId?: string
  date?: string
  enabled?: boolean
}

export function useDailyOverview({ programId, date, enabled = true }: UseDailyOverviewParams = {}) {
  return useQuery({
    queryKey: ['programs', programId, 'daily-overview', date],
    queryFn: async () => {
      const response = await apiClient.get<ProgramDailyOverview>(`/int/v3/programs/${programId}/overview`, {
        params: { date },
      })
      return response.data
    },
    enabled: !!programId && enabled,
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
  })
}
